"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_responsive_modal_1 = __importDefault(require("react-responsive-modal"));
var KaitoriBonusCampaignNoticeModal = function (_a) {
    var message = _a.message;
    var _b = react_1.default.useState(true), isModalOpen = _b[0], setIsModalOpen = _b[1];
    var handleClose = function () {
        setIsModalOpen(false);
    };
    return (react_1.default.createElement(react_responsive_modal_1.default, { open: isModalOpen, onClose: handleClose, classNames: { modal: "kaitoriBonusCampaignNotice-modal", closeButton: "kaitoriBonusCampaignNotice-closeButton" } },
        react_1.default.createElement("div", { className: "kaitoriBonusCampaignNotice-content", dangerouslySetInnerHTML: { __html: message } })));
};
exports.default = KaitoriBonusCampaignNoticeModal;
